<template>
    <div id="displayLetPanel" class="ms-Panel ms-Panel--xxl">
        <span class="ms-Panel-closeButton ms-PanelAction-close">
            <i class="ms-Panel-closeIcon ms-Icon ms-Icon--Cancel"></i>
        </span>
        <div class="ms-Panel-contentInner">
            <div class="ms-Panel-content" id="displayLetBox">

                <iframe id="displayLetIframe"></iframe>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'PanelFullLet',
  props: {
    // msg: String
  }
}
</script>